async function hmac(secret, message) {
  const encoder = new TextEncoder();
  const key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign', 'verify']
  );
  const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(message));
  return Array.from(new Uint8Array(signature))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

const SECRET = process.env.REACT_APP_MASTER_TOKEN_SECRET;
console.log('SECRET:', SECRET);

export async function generateMasterToken() {
  const window60 = Math.floor(Date.now() / 60000);
  return hmac(SECRET, 'master-' + window60);
}